// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-result[data-v-f0a9d6fe]:first-child {\n  margin-top: 24px;\n  border-radius: 4px 4px 0px 0px;\n}\n.search-result[data-v-f0a9d6fe]:not(:first-child) {\n  border-top: 1px solid gray;\n}\n.search-result[data-v-f0a9d6fe]:last-child {\n  border-radius: 0px 0px 4px 4px;\n}", ""]);
// Exports
module.exports = exports;
